import React, { useEffect } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import styled from 'styled-components';

import { useSettlementHooks } from './hooks/useSettlementHooks';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import SettlementFAQ from './components/SettlementFAQ';

import { ICON_NAVIGATE_BACK } from 'assets/icons';
import CommonImage from 'components/common/CommonImage';
import HackleManager from 'utils/hackle';
import SettlementInformation from './components/SettlementInformation';
import WrapperContainer from 'components/common/Wrapper';
import ContentsTopBar from 'components/common/ContentsTopBar';
import { MAX_WIDTH } from 'App';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;

  max-width: 768px;
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: #fff;
`;

const ContentContainer = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  padding: ${props => (props.$isMobile ? '0 20px 16px' : '0 40px 60px')};
  width: 100%;
`;

const SettlementPage = () => {
  const {
    myInfo,
    isRegistRequest,
    handleNavigateBack,
    requestMessage,
    handleSettlementRegistNavigate,
    handleRegistBankPageNavigate,
  } = useSettlementHooks();

  const { width, ref } = useResizeDetector();

  const isMobile = width ? width <= MAX_WIDTH : window.innerWidth <= MAX_WIDTH;

  useEffect(() => {
    HackleManager.logSettlementView();
  }, []);

  return (
    <WrapperContainer isMobile={isMobile}>
      {myInfo && (
        <Container ref={ref}>
          <Header
            style={{
              padding: isMobile ? '24px 20px' : '32px 40px',
              height: isMobile ? '84px' : '100px',
            }}
          >
            <Row gap="16px">
              <CommonImage
                src={ICON_NAVIGATE_BACK}
                onClick={handleNavigateBack}
              />
              <Text color="#1b1c1e" size="24px" style={{ lineHeight: '36px' }}>
                정산 정보 관리
              </Text>
            </Row>
          </Header>
          <ContentContainer $isMobile={isMobile}>
            <SettlementInformation
              hostInfo={myInfo.me.host}
              isRegistRequest={isRegistRequest}
              handleSettlementRegistNavigate={handleSettlementRegistNavigate}
              handleRegistBankPageNavigate={handleRegistBankPageNavigate}
              requestMessage={requestMessage}
            />
            <SettlementFAQ />
          </ContentContainer>
        </Container>
      )}
    </WrapperContainer>
  );
};

export default SettlementPage;
